import { isValidEmailAddress, fadeOutNotifications } from '../functions';

$(document).ready(function() {

	const promotionsWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.promotions-type', this, this.show);
        },
		show(event) {
			const _this = event.data;

			let type = $(this).data('type');

			$('.promotions-type').parent().removeClass('active');
			$(this).parent().addClass('active');

			$(".promotions-wrapper").not("#promotions-type-" + type).hide();
			$("#promotions-type-" + type).show();
		}
    };

    if ($('.promotion-widget-container').length) {
        promotionsWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/promotions-widget.js